import { User } from '../types/user'
import './Avatar.css'

interface AvatarProps {
  user?: Pick<User, 'firstName' | 'lastName' | 'salutation'>
  name?: string
  size?: 'small' | 'medium' | 'large'
  className?: string
}

export function Avatar({ user, name, size = 'medium', className = '' }: AvatarProps) {
  const getInitials = (): string => {
    if (name) {
      const parts = name.trim().split(/\s+/)
      if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
      }
      return name.substring(0, 2).toUpperCase()
    }
    
    if (user) {
      const firstInitial = user.firstName?.[0] || ''
      const lastInitial = user.lastName?.[0] || ''
      return (firstInitial + lastInitial).toUpperCase()
    }
    
    return '??'
  }

  const initials = getInitials()
  
  // Generate a consistent color based on the initials
  const getColor = (text: string): string => {
    let hash = 0
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash)
    }
    
    // Generate a pastel color
    const hue = hash % 360
    return `hsl(${hue}, 65%, 50%)`
  }

  const backgroundColor = user 
    ? getColor(`${user.firstName}${user.lastName}`)
    : getColor(name || 'Unknown')

  return (
    <div 
      className={`avatar avatar-${size} ${className}`}
      style={{ backgroundColor }}
      aria-label={name || (user ? `${user.firstName} ${user.lastName}` : 'User avatar')}
    >
      <span className="avatar-initials">{initials}</span>
    </div>
  )
}

